module.exports = __webpack_public_path__ + "img/about-section-2@2x.0b68547c.jpg";